import { ENV } from 'src/config/environments';

const getApiEndpoint = () => {
    const selectedCity = localStorage.getItem('selectedCity') || ENV.apiEndpoints[0].key;
    const apiEndpoint = ENV.apiEndpoints.find(endpoint => endpoint.key === selectedCity);
    return apiEndpoint ? `${apiEndpoint.url}` : `${ENV.apiEndpoints[0].url}`;
};

const defaultOptions: RequestInit = {
    headers: {
        'Access-Control-Allow-Origin': getApiEndpoint(),
        'Content-Type': 'application/json',
    },
    credentials: 'include',
};

export function getOptions(isMuted = false, headers = {}): RequestInit {
    let combinedHeaders = { ...defaultOptions.headers, ...headers };
    if (isMuted) {
        combinedHeaders = { ...combinedHeaders, 'x-muted': 'true' };
    }
    return { ...defaultOptions, headers: combinedHeaders };
}

function getQuery(paramsObj: any) {
    const params = Object.keys(paramsObj).map(key => `${key}=${paramsObj[key]}`);
    const query = `?${params.join('&')}`;
    return query;
}

export function httpRequest(
    path: string,
    method = 'GET',
    bodyData: any = null,
    queryParams: any = null,
    options: RequestInit = getOptions(),
    isFile = false,
    credentials: RequestCredentials = 'include',
) {
    let body = bodyData || null;
    if (bodyData) {
        body = isFile ? bodyData : JSON.stringify(bodyData);
    }
    const query = queryParams ? getQuery(queryParams) : '';
    const url = `${path}${query}`;
    return fetch(url, {
        method,
        body,
        ...options,
        credentials,
    });
}
